//#region Styles
import { Column, Row } from "components/styles";
import { StyledListTimeItem } from "./styles";
//#endregion
//#region Components
import CustomTime from "components/CustomTimePicker/CustomTimePicker";
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker";
import CustomButton from "components/CustomButton/CustomButton";
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
//#endregion
//#region Icons
import TrashIcon from "icons/TrashIcon";
//#endregion
//#region Services
//#endregion
//#region Utils
import { getDatePartsByMillis } from "components/CustomDatePicker/utils/helpers";
import { useState } from "react";
//#endregion

const ListTimeItem = ({
    idx,
    errors, 
    date,
    inactivity,
    prevInactivity,
    data: { 
        wasModified, 
        time: { start, end }, 
        date: dateItem 
    },
    customDateProps: {
        availableDay
    },
    customTimeProps: {
        ratioMinutesTime,
        intervalTimePicker,
    },
    actions: {
        changeDate,
        changeTime,
        saveChanges,
        openDialogDeleteInactivityQuestion,
        changeInactivity
    }
}) => {
    //#region States
    const [errorInvalidRangeBecauseAlreadyWasSelected, setErrorInvalidRangeBecauseAlreadyWasSelected] = useState(false);
    const currentError = errors[idx];
    const onlyDay = typeof date === "number";
    //#endregion
    //#region Functions
    const checkIfRangeAlreadyWasTaken = () => {
        return inactivity.some(({ 
            time: currentTime, 
            date: currentDate,
            wasModified 
        }, currentIdx) => {
            if (idx === currentIdx || wasModified) return false;
            if (!onlyDay) {
                if (currentDate < 0) return false;
                if (dateItem !== currentDate) return false;
            }
            if ((start >= currentTime.start && end <= currentTime.end) ||
                (start <= currentTime.start && end >= currentTime.end) ||
                (start < currentTime.start && end > currentTime.start) || 
                (start < currentTime.end && end > currentTime.end)) {
                return true;
            }
            return false;
        });
    }
    const saveChangesWithValidation = () => {
        if (start >= 0 && end >= 0 && checkIfRangeAlreadyWasTaken()) {
            // Regresando al valor anterior por ser inválido
            changeInactivity(
                inactivity.map((item, currentIdx) => currentIdx === idx ? prevInactivity.values[idx] : item),
                errors.map((item, currentIdx) => currentIdx === idx ? prevInactivity.errors[idx] : item)
            );
            setErrorInvalidRangeBecauseAlreadyWasSelected(true);
            setTimeout(() => setErrorInvalidRangeBecauseAlreadyWasSelected(false), 2000);
            return;
        }
        setErrorInvalidRangeBecauseAlreadyWasSelected(false);
        saveChanges(idx);
    }
    const changeTimeItem = (field, value) => {
        setErrorInvalidRangeBecauseAlreadyWasSelected(false);
        changeTime(idx, field, value, true);
    }
    //#endregion
    return (
        <Column>
        <StyledListTimeItem
            align={currentError.time.areInvalidTimes ? "center" : "flex-end"}>
            <Row align="flex-start">
                <Column width="max-width">
                    <Row>
                        <CustomTime 
                            label="Desde:"
                            caption="Desde:"
                            value={start}
                            onChange={value => changeTimeItem("start", value)}
                            error={currentError.time.start || currentError.time.areInvalidTimes}
                            interval={intervalTimePicker}
                            ratioMinutesTime={ratioMinutesTime}
                            errorText={!currentError.time.areInvalidTimes ? 
                                "Es necesario seleccionar una hora inicial."
                            : null}
                            />
                        <CustomTime 
                            label="Hasta:"
                            caption="Hasta:"
                            value={end}
                            onChange={value => changeTimeItem("end", value)}
                            error={currentError.time.end || currentError.time.areInvalidTimes}
                            interval={intervalTimePicker}
                            ratioMinutesTime={ratioMinutesTime}
                            errorText={!currentError.time.areInvalidTimes ? 
                                "Es necesario seleccionar una hora final."
                            : null}
                            />
                    </Row>
                    <ErrorMessage 
                        error={currentError.time.areInvalidTimes}
                        text="Las horas son iguales o la hora de inicio es mayor a la de fin."/>
                </Column>
                {onlyDay 
                ? <CustomDatePicker 
                    label="Fecha"
                    value={date}
                    onChange={value => changeDate(idx, value)}
                    disabled/>
                : <CustomDatePicker 
                    label="Fecha"
                    value={dateItem}
                    availableDays={[availableDay]}
                    period={{
                        min: getDatePartsByMillis(date.start),
                        max: getDatePartsByMillis(date.end)
                    }}
                    onChange={value => changeDate(idx, value)}
                    error={currentError.date}
                    errorText="Es necesario seleccionar una fecha."/>}
            </Row>
            {wasModified
            ? <CustomButton 
                text="Guardar"
                size="medium"
                width="100px"
                disabled={currentError.time.areInvalidTimes}
                onClick={saveChangesWithValidation}/>
            : <CustomButton 
                text="Eliminar"
                size="medium"
                width="100px"
                variant="secondary"
                icon={<TrashIcon/>}
                onClick={() => openDialogDeleteInactivityQuestion(idx)}/>}
        </StyledListTimeItem>
        <ErrorMessage 
            text={
                onlyDay
                ? "El rango de horas seleccionado ya fue tomado por otro definido"
                : "El rango de horas o fecha seleccionados ya fue tomado por otro definido"}
            error={errorInvalidRangeBecauseAlreadyWasSelected}/>
        </Column>
    );
}

export default ListTimeItem;